var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	20533: () => (loadSingletonVersion("default", "react", true, [1,18,3,1], () => (() => (__webpack_require__(65043))))),
	40803: () => (loadSingletonVersion("default", "react-dom", true, [1,18,3,1], () => (() => (__webpack_require__(97950))))),
	17745: () => (loadSingletonVersion("default", "mobx", false, [1,6,6,0], () => (__webpack_require__.e(4812).then(() => (() => (__webpack_require__(64812))))))),
	2811: () => (loadStrictVersion("default", "@nivo/bar", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7979), __webpack_require__.e(1271), __webpack_require__.e(116), __webpack_require__.e(2099), __webpack_require__.e(4592), __webpack_require__.e(1903), __webpack_require__.e(2316), __webpack_require__.e(803), __webpack_require__.e(420), __webpack_require__.e(3305)]).then(() => (() => (__webpack_require__(94940))))))),
	5778: () => (loadStrictVersion("default", "snapsvg-cjs", false, [4,0,0,6], () => (__webpack_require__.e(7775).then(() => (() => (__webpack_require__(67775))))))),
	11658: () => (loadStrictVersion("default", "html-to-image", false, [4,1,11,11], () => (__webpack_require__.e(5316).then(() => (() => (__webpack_require__(55316))))))),
	15237: () => (loadStrictVersion("default", "universal-cookie", false, [1,8,0,1], () => (__webpack_require__.e(4750).then(() => (() => (__webpack_require__(34750))))))),
	18543: () => (loadStrictVersion("default", "react-month-picker", false, [1,2,2,1], () => (__webpack_require__.e(8358).then(() => (() => (__webpack_require__(58358))))))),
	19809: () => (loadStrictVersion("default", "axios", false, [1,1,18,0], () => (__webpack_require__.e(8307).then(() => (() => (__webpack_require__(68307))))))),
	24262: () => (loadStrictVersion("default", "@nivo/pie", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7979), __webpack_require__.e(116), __webpack_require__.e(2099), __webpack_require__.e(7686), __webpack_require__.e(803), __webpack_require__.e(420), __webpack_require__.e(3305)]).then(() => (() => (__webpack_require__(47686))))))),
	34849: () => (loadStrictVersion("default", "react-switch", false, [1,7,0,0], () => (__webpack_require__.e(8968).then(() => (() => (__webpack_require__(78968))))))),
	37352: () => (loadStrictVersion("default", "multi-range-slider-react", false, [1,2,0,2], () => (__webpack_require__.e(1284).then(() => (() => (__webpack_require__(71284))))))),
	42096: () => (loadStrictVersion("default", "@idui/react-popover", false, [1,3,1,0], () => (Promise.all([__webpack_require__.e(5892), __webpack_require__.e(803)]).then(() => (() => (__webpack_require__(45892))))))),
	42232: () => (loadStrictVersion("default", "@syncfusion/ej2-react-grids", false, [1,27,1,50], () => (Promise.all([__webpack_require__.e(115), __webpack_require__.e(803)]).then(() => (() => (__webpack_require__(90115))))))),
	45904: () => (loadStrictVersion("default", "react-apexcharts", false, [1,1,4,1], () => (__webpack_require__.e(2576).then(() => (() => (__webpack_require__(62576))))))),
	47239: () => (loadStrictVersion("default", "react-select", false, [1,5,2,1], () => (Promise.all([__webpack_require__.e(623), __webpack_require__.e(803)]).then(() => (() => (__webpack_require__(40623))))))),
	56249: () => (loadStrictVersion("default", "react-markdown", false, [1,10,1,0], () => (__webpack_require__.e(159).then(() => (() => (__webpack_require__(70159))))))),
	57538: () => (loadSingletonVersion("default", "mobx-react", false, [1,7,5,0], () => (Promise.all([__webpack_require__.e(6233), __webpack_require__.e(803)]).then(() => (() => (__webpack_require__(96233))))))),
	64628: () => (loadStrictVersion("default", "react-router-dom", false, [1,5,2,0], () => (Promise.all([__webpack_require__.e(2522), __webpack_require__.e(7440)]).then(() => (() => (__webpack_require__(52522))))))),
	66840: () => (loadStrictVersion("default", "d3", false, [1,7,9,0], () => (Promise.all([__webpack_require__.e(7979), __webpack_require__.e(1271), __webpack_require__.e(1320), __webpack_require__.e(3037), __webpack_require__.e(1965), __webpack_require__.e(420)]).then(() => (() => (__webpack_require__(1965))))))),
	70298: () => (loadStrictVersion("default", "react-table", false, [1,7,8,0], () => (__webpack_require__.e(1094).then(() => (() => (__webpack_require__(71094))))))),
	70552: () => (loadStrictVersion("default", "@nivo/line", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7979), __webpack_require__.e(1271), __webpack_require__.e(116), __webpack_require__.e(2099), __webpack_require__.e(4592), __webpack_require__.e(1320), __webpack_require__.e(1903), __webpack_require__.e(9648), __webpack_require__.e(803), __webpack_require__.e(420), __webpack_require__.e(3305)]).then(() => (() => (__webpack_require__(79648))))))),
	79149: () => (loadStrictVersion("default", "react-bootstrap", false, [2,0,33,1], () => (Promise.all([__webpack_require__.e(5726), __webpack_require__.e(803)]).then(() => (() => (__webpack_require__(55726))))))),
	80276: () => (loadStrictVersion("default", "jspdf", false, [1,4,2,1], () => (__webpack_require__.e(6396).then(() => (() => (__webpack_require__(6396))))))),
	87374: () => (loadStrictVersion("default", "react-d3-speedometer", false, [1,3,1,1], () => (__webpack_require__.e(9139).then(() => (() => (__webpack_require__(9139))))))),
	96336: () => (loadStrictVersion("default", "query-string", false, [1,7,1,1], () => (__webpack_require__.e(9370).then(() => (() => (__webpack_require__(9370))))))),
	99065: () => (loadStrictVersion("default", "react-error-boundary", false, [1,3,1,4], () => (__webpack_require__.e(9177).then(() => (() => (__webpack_require__(59177))))))),
	10420: () => (loadStrictVersion("default", "d3-color", false, [1,3,1,0], () => (__webpack_require__.e(4884).then(() => (() => (__webpack_require__(34884))))))),
	93305: () => (loadStrictVersion("default", "@nivo/core", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(1271), __webpack_require__.e(4592), __webpack_require__.e(3037), __webpack_require__.e(5652)]).then(() => (() => (__webpack_require__(25652))))))),
	20804: () => (loadStrictVersion("default", "decode-uri-component", false, [2,0,2,1], () => (__webpack_require__.e(5707).then(() => (() => (__webpack_require__(95707))))))),
	80031: () => (loadStrictVersion("default", "apexcharts", false, [1,3,53,0], () => (__webpack_require__.e(3606).then(() => (() => (__webpack_require__(43606))))))),
	7440: () => (loadStrictVersion("default", "path-to-regexp", false, [1,3,3,0], () => (__webpack_require__.e(4340).then(() => (() => (__webpack_require__(44340))))))),
	32699: () => (loadStrictVersion("default", "web-vitals", false, [1,2,1,4], () => (__webpack_require__.e(6453).then(() => (() => (__webpack_require__(46453)))))))
};
const initialConsumes = [20533];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		const factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
const chunkMapping = {
	"420": [
		10420
	],
	"803": [
		40803
	],
	"2576": [
		80031
	],
	"2699": [
		32699
	],
	"3305": [
		93305
	],
	"7440": [
		7440
	],
	"7745": [
		17745
	],
	"8792": [
		20533
	],
	"9229": [
		2811,
		5778,
		11658,
		15237,
		18543,
		19809,
		24262,
		34849,
		37352,
		42096,
		42232,
		45904,
		47239,
		56249,
		57538,
		64628,
		66840,
		70298,
		70552,
		79149,
		80276,
		87374,
		96336,
		99065
	],
	"9370": [
		20804
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}